import {CellTitleSiBox} from "./cell-title.si.box";

export const CellTitleSiCisBox = CellTitleSiBox;